import classnames from 'classnames'
import React, { ReactElement } from 'react'
import './PillButton.scss'

interface PillButtonProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
  label?: string
  isLink?: boolean
  color?: 'green' | 'red' | 'blue'
  className?: string
  icon?: ReactElement
}

const PillButton = ({
  onClick,
  disabled = false,
  label,
  isLink = false,
  color = 'green',
  className,
  icon
}: PillButtonProps) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={classnames('pill-button', color, className)}
      role={isLink ? 'link' : 'button'}
      aria-label={label}
    >
      {icon}
      {label}
    </button>
  )
}

export default PillButton
